import "./style/style2.css"

import Footer from './Footer';


import odenloFigmaV1 from './images/odenlo/odenlo-UX-UI-Design-version1.png';
import odenloFigmaListPV1 from './images/odenlo/List-page-odenlo-UX-UI-Design-version1.png';
import odenloThumb from "./images/odenlo/listing-UI-reactjs.jpg"
import skeletonThumb from "./images/odenlo/skeleton-loading-reactjs.jpg"
import odenloVideo1 from './images/odenlo/odenlo-demo-1-choice-and-list-page-react-nextjs.mp4';

import odenloVideoSkeletons from './images/odenlo/skeleton-loading-react-pages.mp4';

import arrowIcon from './images/arrow.svg'

import folioOdenlo from './images/Odenlo - Frontend-Developer-React-Nextjs.jpg'

import { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import ScrollToTop from './ScrollToTop';
import ProjectNav from "./Project_Nav";

export default function ProjectOdenlo() {

  const [TransY, setTransY] = useState('translateY(333px)');
  const [OpacityB, setOpacityB] = useState('0.0');



  useEffect(() => {
    // This will be called after the initial render
    setOpacityB('1');
    setTransY('translateY(0px)');
  }, []);



  return (
    <ScrollToTop>
      {/*<motion.div initial= {{y: 333, opacity:0}} animate= {{y: 0, opacity:1}} exit= {{opacity: 0}} transition = {{ duration: 1, ease: [0.22, 1, 0.36, 1]}}>*/}

      <div class="projectPage">

        {/* Navigation Arrows */}
        <div style={{ position: 'fixed', top: '13px', left: '13px', 'z-index': '55', opacity: OpacityB }}>
          <div style={{ position: 'absolute', transform: 'rotate(-134deg)' }}>
            <Link to="/" style={{ 'text-decoration': 'none' }}>
              <div class='iconCircle'><img src={arrowIcon} style={{ margin: '0px', transform: 'translate(-2px,-3px)' }} /></div>
            </Link>
          </div>
        </div>
        <div style={{ position: 'fixed', bottom: '67px', right: '67px', 'z-index': '55', opacity: OpacityB }}>
          <div style={{ position: 'absolute', transform: 'rotate(-45deg)' }}>
            <a href="#top" style={{ cursor: 'default' }}>
              <div class='iconCircle'><img src={arrowIcon} style={{ margin: '0px', transform: 'translate(-1px,-2px)' }} /></div>
            </a>
          </div>
        </div>

        <div className="bar" style={{ 'background-color': '#1d54de', opacity: OpacityB }}>
          <img src={folioOdenlo} style={{ opacity: OpacityB, transform: "translateY(37px)" }} />
        </div>
        <div className="bar2" style={{ 'background-color': '#1d54de', transform: TransY, opacity: OpacityB, position: 'sticky', top: 0 }}>
          <div class="projectHeader">
            <div class="textBoxLeft">
              <div class="smallText">Client:</div>
              <div class="projectTitle">Odenlo<br /></div>
            </div>
            <div class="projectTitleRight">
              <div class="smallText">Summary</div>
              <div class="projectTitle">
                I engineered a modern frontend architecture using React and Next.js, prioritizing modularity and reusability.</div>
            </div>
          </div>

          <div class="projectHeader">
            <div class="textBoxLeft">
              <div class="smallText">Role:</div>
              <div class="projectTitle">Fullstack Developer </div>
            </div>
            <div class="projectTitleRight">
              <div class="smallText">Tech:</div>
              <div class="projectTitle">React, Next.js, Node.js, PostgreSQL, Supabase, Zustand</div>
            </div>
          </div>
        </div>

        <div class="Rido" style={{ top: '0px', 'background-color': '#ffffff', opacity: '1', 'z-index': '-2' }}></div>

        <div class="ProjectContainer" style={{ transform: TransY, opacity: OpacityB }}>
          <div class="section">
            <div class="oneColumnIntro">
              <h2>Introduction</h2>
              <div class="IntroTexts">Odenlo is an online platform that connects real estate agents and property owners with renters through a user-friendly search experience for discovering and booking short- and long-term stays in homes, apartments, and unique venues.</div>
            </div>
          </div>


          <div class="GrayBG">

            <div class="smallTitle">First Version's UI Design</div>
            <div class="bigTitle">Maximum info <br /> at a Glance</div>

            <div style={{ borderRadius: '23px', overflow: 'auto', position: 'relative', padding: '33px' }} >
              <div style={{ padding: '11px 33px', backgroundColor: '#fff', position: 'absolute', opacity: '.7', borderRadius: '0 0 11px 0' }}> UI Design on Figma </div>
              <img src={odenloFigmaV1} style={{ width: '100%', maxWidth: '1223px', borderRadius: '23px' }} alt="odenlo-UX-UI-Design-version1-figma" />
            </div>

            <div class="commentSection" style={{ width: '90%', maxWidth: '1223px', margin: '53px 0', gap: '23px' }}>

              <img src={odenloFigmaListPV1} style={{ width: '70%', maxWidth: '723px', borderRadius: '5px' }} alt="odenlo-UX-UI-Design-version1-figma" />

              <div class="commentColumn">
                <h3>Appartments List Page (V1)</h3>
                <p>Initially, the Odenlo app was designed to cater specifically to the German WG (Wohngemeinschaft) or shared apartment market.</p>
                <p>Using Figma, I crafted a <strong>user-centric UI </strong>that allowed for intuitive comparison of listings at a glance based on key criteria such as:</p>
                <ul>
                  <li>Number of flatmates</li>
                  <li>Gender distribution (in Shared Flats)</li>
                  <li>Rent type (Cold vs. Warm)</li>
                  <li>and amenities</li>
                </ul>
              </div>
            </div>

            <div style={{ fontStyle: 'italic', fontSize: '16px', fontWeight: 'bold', padding: '11px 33px' }}>
              Following market analysis, the product team decided to pivot toward a broader audience by targeting the UK rental market.
            </div>

          </div>

          {//Recherche processess
          }
          <div class="smallTitle">  Building the Rental Marketplace with React & Next.js</div>
          <div class="bigTitle">From Design to Code</div>


          <div id='flexColCenter' style={{ width: '100%', maxWidth: '993px' }}>

            <p style={{ padding: '0 33px' }}>
              After finishing the UI/UX design phase, we brought the application to life using <strong>React</strong> and
              <strong> Next.js</strong> to ensure a fast, modular, and scalable frontend architecture. The goal was to transform our
              wireframes and prototypes into a performant and accessible rental platform that delivers real value to users.
            </p>


            <video
              style={{ borderRadius: '9px', boxShadow: '0px 0px 3px #aaa', margin: '23px 11px' }}
              controls="true" autoplay="true"
              loop="true"
              muted
              playsInline
              width="100%"
              poster={odenloThumb} >
              <source src={odenloVideo1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>


            <div style={{ padding: '11px 33px 33px 33px' }}>

              <ul id='flexColCenter' >
                <li>
                  <strong>Modern Frontend Architecture:</strong><br />
                  Built reusable and maintainable components with React, applying a modular design system that supports scalability
                  and consistency across the platform. I built all UI elements from scratch without using a UI library to ensure full control over design and consistency.
                </li>
                <li>
                  <strong>Server-Side Rendering with Next.js:</strong><br />
                  Dynamic rental property pages were implemented with SSR to enhance SEO and improve load performance, ensuring
                  that listings are indexed properly by search engines.
                </li>

                     <li>
                  <strong>Global State Management via Zustand:</strong><br />
                  To manage state across components without excessive prop-drilling, we integrated Zustand, enabling a simpler,
                  more scalable solution for shared state.
                </li>

                 <li>
                  <strong>Skeleton Loading States:</strong><br />
                  To enhance perceived performance, we used skeleton loaders for key components like property cards and filters,
                  reducing user frustration during data fetching.
                </li>

                <video
                  style={{ borderRadius: '9px', boxShadow: '0px 0px 3px #aaa', margin: '23px 11px', transform: 'translateX(-17px)' }}
                  controls="true" autoplay="true"
                  loop="true"
                  muted
                  playsInline
                  width="100%"
                  poster={skeletonThumb} >
                  
                  <source src={odenloVideoSkeletons} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
           
                <li>
                  <strong>Secure User Authentication with Supabase:</strong><br />
                  We implemented user login, registration, and role-based access control using Supabase Auth, providing a secure
                  and smooth authentication flow.
                </li>


                <li>
                  <strong>Performance Optimization:</strong><br />
                  We improved page load performance by more than <strong>40%</strong> (measured with Google PageSpeed) through strategic
                  code splitting, image optimization (lazy loading), and caching.
                </li>

              </ul>



            </div>
                   <strong style={{marginBottom: '33px'}}><em>Thank you for taking the time to explore this project !</em></strong>
              <div style={{marginBottom: '33px'}}>Link to the project: <a href='https://odenlo.com'>odenlo.com</a></div>
          </div>


          <ProjectNav NextProject='/project-dishop' PrevProject='/' />

          <Footer />
        </div>

      </div>




    </ScrollToTop>
  )

}
